module.exports = __webpack_public_path__ + "img/6_124.9132bc80.png";